import { render, staticRenderFns } from "./MinimalSearch.vue?vue&type=template&id=6ad901f4"
import script from "./MinimalSearch.vue?vue&type=script&lang=js"
export * from "./MinimalSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports